import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import {
  getKYCListingForm,
  toggleKYCActive,
  getKYCContractStatusDDL,
  getKycSingleRecord,
  updateUserKycProcess,
  changeContractStatusForWeb,
  getAppGlobalSettingByVariableName,
  getComplianceDocuments,
  submitCreditBookV2KYC,
  saveCustomerInfoToUpdateByKycId,
} from "./KYCListingFormActions";
import KYCListingFormComplianceModal from "./KYCListingFormComplianceModal";
import KYCListingFormComplianceViewModal from "./KYCListingFormComplianceViewModal";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import {
  Modal,
  Row,
  Col,
  Container,
  Button,
  Overlay,
  Popover,
  toggleUserStatus,
} from "react-bootstrap";
import Moment from "react-moment";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";

import axios from "../../../apis/Api";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link, Redirect } from "react-router-dom";
import { formatDate, toCommaSeparated } from "../../../utilities/FUNCTIONS";
import ReactToPrint from "react-to-print";
import PlaceholderImage from "../../../assets/Images/placeholder-image.png";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../../utilities/ImageUpload";
import { isPermittedPage } from "../../../apis/Utility";
import { getImageExtensions } from "../../../utilities/FUNCTIONS";
import {
  AllowOnlyAlpha,
  AllowOnlyDecimal,
  AllowOnlyNumeric,
  formatNumber,
  removeFormatFromNumber,
  AllowOnlyAlphaNumericWithDash,
} from "../../../utilities/Validations";
import {
  getValue,
  normalizeFieldToken,
  unwrapResponseEnvelope,
  isRejected,
} from "./KYCListingFormCommon";

const normalizeComplianceDetails = (details) =>
  (Array.isArray(details) ? details : []).map((detail) => ({
    ...detail,
    requirementName:
      getValue(detail, "requirementName", "RequirementName", "name", "Name") || "",
    values: getValue(detail, "values", "Values", "value", "Value") || [],
    status: getValue(detail, "status", "Status"),
    valueStatuses:
      getValue(detail, "valueStatuses", "ValueStatuses", "statuses", "Statuses") || [],
  }));

const normalizeRequirementName = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, "_")
    .toLowerCase();

const normalizeBusinessType = (value) =>
  String(value || "")
    .trim()
    .replace(/[\s-]+/g, "_")
    .toLowerCase();


const extractRejectedFieldEntries = (fields = []) =>
  (Array.isArray(fields) ? fields : [])
    .map((field) => {
      if (typeof field === "string") {
        return { name: field, rejected: true };
      }

      const name =
        getValue(field, "name", "fieldName", "key", "requirementName", "RequirementName") || "";
      const statusCurrent = getValue(field?.status, "current", "Current");
      const explicitStatus = getValue(field, "status", "Status");
      const isEntryRejected =
        isRejected(statusCurrent) || isRejected(explicitStatus) || field?.isRejected === true;

      return {
        ...field,
        name,
        rejected: isEntryRejected,
      };
    })
    .filter((field) => field?.name && field.rejected);

const entityFieldDescriptors = [
  {
    aliases: ["name", "personalname"],
    path: "personalDetails.name",
    entity: "personal",
    requestKey: "name",
    valueGetter: (formData) => formData.personalDetails?.name,
  },
  {
    aliases: ["contactnumber", "personalcontactnumber"],
    path: "personalDetails.contactNumber",
    entity: "personal",
    requestKey: "contactNumber",
    valueGetter: (formData) => formData.personalDetails?.contactNumber,
  },
  {
    aliases: ["email", "personalemail"],
    path: "personalDetails.email",
    entity: "personal",
    requestKey: "email",
    valueGetter: (formData) => String(formData.personalDetails?.email || "").trim(),
  },
  {
    aliases: ["dob", "dateofbirth", "personaldob"],
    path: "personalDetails.dob",
    entity: "personal",
    requestKey: "dob",
    valueGetter: (formData) => formData.personalDetails?.dob,
  },
  {
    aliases: ["nationaldocumentid", "cnic", "personalnationaldocumentid", "personalcnic"],
    path: "personalDetails.cnic",
    entity: "personal",
    requestKey: "nationalDocumentId",
    valueGetter: (formData) => removeFormatFromNumber(formData.personalDetails?.cnic || ""),
  },
  {
    aliases: ["businessname"],
    path: "businessDetails.businessName",
    entity: "business",
    requestKey: "businessName",
    valueGetter: (formData) => formData.businessDetails?.businessName,
  },
  {
    aliases: ["businessnationaldocumentid", "businesscnic"],
    path: "businessDetails.cnic",
    entity: "business",
    requestKey: "nationalDocumentId",
    valueGetter: (formData) => removeFormatFromNumber(formData.businessDetails?.cnic || ""),
  },
  {
    aliases: ["streetaddress", "businessstreetaddress"],
    path: "businessDetails.businessAddress.streetAddress",
    entity: "business",
    requestKey: "streetAddress",
    valueGetter: (formData) => formData.businessDetails?.businessAddress?.streetAddress,
  },
  {
    aliases: ["city", "businesscity"],
    path: "businessDetails.businessAddress.city",
    entity: "business",
    requestKey: "city",
    valueGetter: (formData) => formData.businessDetails?.businessAddress?.city,
  },
  {
    aliases: ["state", "businessstate"],
    path: "businessDetails.businessAddress.state",
    entity: "business",
    requestKey: "state",
    valueGetter: (formData) => formData.businessDetails?.businessAddress?.state,
  },
  {
    aliases: ["country", "businesscountry"],
    path: "businessDetails.businessAddress.country",
    entity: "business",
    requestKey: "country",
    valueGetter: (formData) => formData.businessDetails?.businessAddress?.country,
  },
  {
    aliases: ["creditlimitrequired", "requiredcredit"],
    path: "creditLimitRequired",
    entity: "business",
    requestKey: "creditLimitRequired",
    valueGetter: (formData) => Number(formData.creditLimitRequired),
  },
];

const findFieldDescriptor = (fieldName) => {
  const normalized = normalizeFieldToken(fieldName);
  if (!normalized) return null;

  return (
    entityFieldDescriptors.find((descriptor) => descriptor.aliases.includes(normalized)) ||
    entityFieldDescriptors.find((descriptor) =>
      descriptor.aliases.some((alias) => normalized.endsWith(alias) || normalized.includes(alias))
    ) ||
    null
  );
};

const getEditableV2Fields = (kycData) => {
  if (!kycData) return [];

  const editable = new Set();

  extractRejectedFieldEntries(kycData.customerInfoFields).forEach((entry) => {
    const descriptor = findFieldDescriptor(entry.name);
    if (descriptor) editable.add(descriptor.path);
  });

  // Build fallback set from complianceFields array (older response shape)
  const rejectedComplianceNames = new Set(
    extractRejectedFieldEntries(kycData.complianceFields).map((field) => normalizeFieldToken(field.name))
  );

  const isComplianceDetailRejected = (detail) =>
    isRejected(detail?.status) ||
    rejectedComplianceNames.has(normalizeFieldToken(detail?.requirementName));

  (kycData.personalDetails?.complianceDetails || []).forEach((detail, detailIndex) => {
    if (isComplianceDetailRejected(detail)) {
      const values = Array.isArray(detail.values) ? detail.values : [];
      values.forEach((_, valueIndex) => {
        editable.add(`personalDetails.complianceDetails.${detailIndex}.values.${valueIndex}`);
      });
      if (values.length === 0) {
        editable.add(`personalDetails.complianceDetails.${detailIndex}.values.0`);
      }
    }
  });

  (kycData.businessDetails?.complianceDetails || []).forEach((detail, detailIndex) => {
    if (isComplianceDetailRejected(detail)) {
      const values = Array.isArray(detail.values) ? detail.values : [];
      values.forEach((_, valueIndex) => {
        editable.add(`businessDetails.complianceDetails.${detailIndex}.values.${valueIndex}`);
      });
      if (values.length === 0) {
        editable.add(`businessDetails.complianceDetails.${detailIndex}.values.0`);
      }
    }
  });

  return [...editable];
};

const pickRejectedComplianceDetails = (details = [], prefix, editableSet) => {
  const selected = [];

  details.forEach((detail, detailIndex) => {
    const values = Array.isArray(detail?.values) ? detail.values : [];
    const selectedByPath = values.filter((_, valueIndex) =>
      editableSet.has(`${prefix}.${detailIndex}.values.${valueIndex}`)
    );
    const requirementExplicitlySelected = editableSet.has(`${prefix}.${detailIndex}.values.0`);
    const filteredValues = selectedByPath.filter(
      (value) => value !== undefined && value !== null && String(value).trim() !== ""
    );

    if (filteredValues.length > 0 || requirementExplicitlySelected) {
      selected.push({
        RequirementName: detail?.requirementName,
        Values: filteredValues,
      });
    }
  });

  return selected;
};

const buildV2RejectedPayload = (formData, editableFields = []) => {
  const editableSet = new Set(editableFields || []);
  const personalEntityUpdates = {};
  const businessEntityUpdates = {};

  entityFieldDescriptors.forEach((descriptor) => {
    if (!editableSet.has(descriptor.path)) return;

    if (descriptor.entity === "personal") {
      personalEntityUpdates[descriptor.requestKey] = descriptor.valueGetter(formData);
      return;
    }

    businessEntityUpdates[descriptor.requestKey] = descriptor.valueGetter(formData);
  });

  const personalCompliance = pickRejectedComplianceDetails(
    formData.personalDetails?.complianceDetails || [],
    "personalDetails.complianceDetails",
    editableSet
  );
  const businessCompliance = pickRejectedComplianceDetails(
    formData.businessDetails?.complianceDetails || [],
    "businessDetails.complianceDetails",
    editableSet
  );

  return {
    PersonalEntity: {
      EntityUpdates: personalEntityUpdates,
      ComplianceDetails: personalCompliance,
    },
    BusinessEntity: {
      EntityUpdates: businessEntityUpdates,
      ComplianceDetails: businessCompliance,
    },
  };
};

const getComplianceRequirements = (complianceDocuments) => {
  if (Array.isArray(complianceDocuments)) return complianceDocuments;
  if (Array.isArray(complianceDocuments?.requirements)) return complianceDocuments.requirements;
  if (Array.isArray(complianceDocuments?.response?.requirements)) {
    return complianceDocuments.response.requirements;
  }
  return [];
};

const isMultipleFileRequirement = (requirement) => {
  const validations = requirement?.validations || {};
  const tags = [
    requirement?.tag,
    requirement?.tags,
    requirement?.Tag,
    requirement?.Tags,
    validations.tag,
    validations.tags,
    validations.Tag,
    validations.Tags,
  ]
    .flat()
    .filter(Boolean)
    .map((tag) => String(tag).trim().toLowerCase());
  const multipleValue =
    requirement?.allow_multi_images ??
    requirement?.allowMultiImages ??
    requirement?.allow_multiple_files ??
    requirement?.allowMultipleFiles ??
    requirement?.allow_multiple ??
    requirement?.allowMultiple ??
    requirement?.multiple ??
    requirement?.is_multiple ??
    requirement?.isMultiple ??
    validations.allow_multi_images ??
    validations.allowMultiImages ??
    validations.allow_multiple_files ??
    validations.allowMultipleFiles ??
    validations.allow_multiple ??
    validations.allowMultiple ??
    validations.multiple ??
    validations.is_multiple ??
    validations.isMultiple;

  if (typeof multipleValue === "string") {
    return ["true", "1", "yes"].includes(multipleValue.toLowerCase());
  }

  return (
    multipleValue === true ||
    multipleValue === 1 ||
    tags.includes("allowmultiimages") ||
    tags.includes("allow_multi_images") ||
    tags.includes("allowmultiplefiles") ||
    tags.includes("allow_multiple_files")
  );
};

const enrichComplianceDetails = (details, complianceDocuments, businessType, entityType) => {
  const normalizedBusinessType = normalizeBusinessType(businessType);
  const requirements = getComplianceRequirements(complianceDocuments);

  return normalizeComplianceDetails(details)
    .map((detail) => {
      const matchedRequirement = requirements.find((requirement) => {
        const sameRequirement =
          normalizeRequirementName(requirement.requirement_name) ===
          normalizeRequirementName(detail.requirementName);
        const sameEntity = !entityType || requirement.entity_type === entityType;
        const supportsBusinessType =
          !Array.isArray(requirement.business_types) ||
          requirement.business_types
            .map((type) => normalizeBusinessType(type))
            .includes(normalizedBusinessType);

        return sameRequirement && sameEntity && supportsBusinessType;
      });

      if (!matchedRequirement) return null;

      return {
        ...detail,
        dataType: matchedRequirement.data_type,
        displayLabel: matchedRequirement.display_label,
        enumValues: matchedRequirement.validations?.enum_values || [],
        inputType: matchedRequirement.input_type,
        acceptedFormats: matchedRequirement.validations?.accepts_formats || [],
        allowMultipleFiles:
          detail.allowMultipleFiles === true ||
          isMultipleFileRequirement(detail) ||
          isMultipleFileRequirement(matchedRequirement),
      };
    })
    .filter(Boolean);
};

const normalizeV2Kyc = (response, complianceDocuments = null) => {
  const wrapped = unwrapResponseEnvelope(response);
  const kycData = getValue(wrapped, "kycData", "KycData") || wrapped || {};
  const personal = getValue(kycData, "personalDetails", "PersonalDetails") || {};
  const business = getValue(kycData, "businessDetails", "BusinessDetails") || {};
  const address = getValue(business, "businessAddress", "BusinessAddress") || {};
  const coordinates = getValue(address, "coordinates", "Coordinates");
  const dob = getValue(personal, "dob", "Dob");
  const businessType = getValue(business, "businessType", "BusinessType") || "";
  const complianceFields = Array.isArray(kycData?.complianceFields) ? kycData.complianceFields : [];
  const complianceStatusByName = new Map(
    complianceFields.map((item) => [
      normalizeFieldToken(getValue(item, "name", "Name", "requirementName", "RequirementName")),
      getValue(item?.status, "current", "Current") || getValue(item, "status", "Status"),
    ])
  );

  return {
    customerInfoFields: Array.isArray(kycData.customerInfoFields) ? kycData.customerInfoFields : [],
    complianceFields,
    personalDetails: {
      name: getValue(personal, "name", "Name") || "",
      contactNumber: getValue(personal, "contactNumber", "ContactNumber") || "",
      email: getValue(personal, "email", "Email") || "",
      dob: dob ? String(dob).slice(0, 10) : "",
      cnic:
        getValue(
          personal,
          "cnic",
          "cNIC",
          "CNIC",
          "nationalDocumentId",
          "NationalDocumentId"
        ) || "",
      complianceDetails: enrichComplianceDetails(
        getValue(personal, "complianceDetails", "ComplianceDetails"),
        complianceDocuments,
        businessType,
        "individual"
      ),
    },
    businessDetails: {
      businessName: getValue(business, "businessName", "BusinessName") || "",
      businessType,
      businessAddress: {
        streetAddress: getValue(address, "streetAddress", "StreetAddress") || "",
        city: getValue(address, "city", "City") || "",
        state: getValue(address, "state", "State") || "",
        country: getValue(address, "country", "Country") || "",
        coordinates: {
          lat: getValue(coordinates, "lat", "Lat") ?? "",
          long: getValue(coordinates, "long", "Long", "lng", "Lng") ?? "",
        },
      },
      cnic:
        getValue(
          business,
          "cnic",
          "cNIC",
          "CNIC",
          "nationalDocumentId",
          "NationalDocumentId"
        ) || "",
      complianceDetails: enrichComplianceDetails(
        getValue(business, "complianceDetails", "ComplianceDetails"),
        complianceDocuments,
        businessType,
        "business"
      ),
    },
    vizshopId: getValue(kycData, "vizshopId", "VizshopId", "vizShopId", "VizShopId") || "",
    lenderId:
      getValue(kycData, "lenderId", "LenderId") ||
      getValue(response, "lenderId", "LenderId") ||
      "",
    userId:
      getValue(kycData, "userId", "UserId") ||
      getValue(response, "userId", "UserId", "financerId", "FinancerId") ||
      "",
    creditLimitRequired:
      getValue(kycData, "creditLimitRequired", "CreditLimitRequired") ??
      getValue(response, "creditRequired", "CreditRequired") ??
      "",
    vizId: getValue(wrapped, "vizId", "vizID", "VizId", "VizID") || "",
    financerId: getValue(wrapped, "financerId", "FinancerId") || "",
    kycStatus:
      getValue(wrapped, "kycStatusStr", "KycStatusStr") ||
      getValue(wrapped, "kycStatus", "KycStatus") ||
      "",
    contractStatus:
      getValue(wrapped, "contractStatus", "ContractStatus") ||
      getValue(wrapped, "agreementStatus", "AgreementStatus") ||
      "",
    assignLimit:
      getValue(wrapped, "assignLimit", "AssignLimit") ??
      getValue(kycData, "assignLimit", "AssignLimit") ??
      "",
    reason:
      getValue(wrapped, "reason", "Reason", "rejectionReason", "RejectionReason") ||
      getValue(kycData, "reason", "Reason", "rejectionReason", "RejectionReason") ||
      "",
  };
};

const KYCListingForm = (props) => {
  const dispatch = useDispatch();
  const [selectedKyc, setSelectedKyc] = useState(null);
  const [originalKycData, setOriginalKycData] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const cellRefs = useRef({});

  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [appVersion, setAppVersion] = useState(null);
  const [isV2Compliance, setIsV2Compliance] = useState(false);
  const [showV2ComplianceModal, setShowV2ComplianceModal] = useState(false);
  const [editableV2Fields, setEditableV2Fields] = useState([]);

  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const printRef = useRef();
  const imgUploadRef = useRef();

  // pagination states
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [isContractButtonVisible, setIsContractButtonVisible] = useState(false);

  const [ContractStatusOption, setContractStatusOption] = useState([]);
  const [distCenterOptions, setDistCenterOptions] = useState(
    props.selectedAddJobDistCentersList ?? []
  );

  const kycList = props.KYCListingForm?.data ?? [];
  const totalRecords = props.KYCListingForm?.totalRecords ?? 0;

  const filterInitialValues = {
    fromDate: new Date(),
    toDate: new Date(),
    shopId: "",
    status: "",
    pageNo: 0,
    searchText: "",
    distributorId: [],
    distcentId: [],
    lenderId: [],
    contractStatus: "",
  };

  const modalInitialValues = {
    id: "",
    cnicBack: "",
    lenderId: "",
    cnicFront: "",
    shopPicture: "",
    ownerPicture: "",
    date: new Date(),
    dateStr: new Date(),
    ownershipType: "",
    shopHeight: 0,
    shopWidth: 0,
    vizId: "",
    financerId: "",
    kycStatus: "",
    contractStatus: "",
    assignLimit: 0,
    reason: "",
    dateOfBirth: new Date(),
    ownerName: "",
    fatherName: "",
    motherName: "",
    cnic: "",
    cnicIssuanceDate: new Date(),
    cnicExpiryDate: new Date(),

    email: "",
    contactNo: "",
    cnicHomeAddress: "",
    currentHomeAddress: "",
    businessName: "",
    businessType: "",
    requiredCredit: 0,
    businessAddress: "",
    userName: "",
  };

  const [filter, setfilter] = useState(filterInitialValues);
  const [modalValues, setModalValues] = useState(modalInitialValues);
  const KycStatusString = (status) => {
    return status.replace("", "");
  };
  const columns = [
    {
      Header: "Kyc Submission Date",
      accessor: "kycSubmissionDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: "VIZ-ID",
      accessor: "vizID",
    },

    {
      Header: "Shop Name",
      accessor: "shopName",
    },

    {
      Header: "Kyc Status",
      accessor: "kycStatusStr",
    },
    {
      Header: "Contract Status",
      accessor: "contractStatus",
    },
    {
      Header: "Active Status",
      id: "activeStatus",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button
            title="Toggle User Active Status"
            onClick={() => toggleActive(original.id)}
            className=" btn btn-sm"
            ref={(el) => (cellRefs.current[original.id] = el)}
            style={{ color: "#e84d15", backgroundColor: "transparent" }}
          >
            <i
              className={
                original.activeStatus
                  ? "fas fa-toggle-on fa-2x"
                  : "fas fa-toggle-off fa-2x"
              }
            ></i>
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      id: "id",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div className="d-flex" style={{ width: "106px" }}>
          <button
            style={{
              display:
                original.kycStatusStr === "Pending" ||
                  original.kycStatusStr === "Approved"
                  ? "none"
                  : "block",
            }}
            onClick={() => editRecord(original.id)}
            className=" btn btn-sm"
          >
            <i className="fas fa-edit"></i>
          </button>
          &nbsp;
          <button
            onClick={() => viewRecord(original.id, false)}
            className="btn btn-sm"
          >
            <i className="fas fa-eye"></i>
          </button>
          {/* &nbsp;
          <button onClick={() => Delete(row.value)} className='btn btn-sm'>
            <i className='fas fa-trash'></i>
          </button> */}
        </div>
      ),
    },
  ];

  const statusOptions = [
    {
      label: "Pending",
      value: 5,
    },
    {
      label: "Approved",
      value: 6,
    },
    {
      label: "Rejected",
      value: 7,
    },
    {
      label: "Need More Info",
      value: 8,
    },
    {
      label: "Error",
      value: 9,
    },
  ];

  const ownershipColumns = [
    {
      label: "Owned",
      value: "owned",
    },
    {
      label: "Rented",
      value: "rented",
    },
  ];

  const fetchReportData = (request) => {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getKYCListingForm(finalRequest);
  };

  const toggleActive = async (Id) => {
    props.toggleKYCActive(Id, (active) => {
      if (cellRefs.current[Id]) {
        if (active) {
          cellRefs.current[Id].innerHTML =
            '<i class="fas fa-toggle-on fa-2x"></i>';
        } else {
          cellRefs.current[Id].innerHTML =
            '<i class="fas fa-toggle-off fa-2x"></i>';
        }
      }
      toast.success("User status updated successfully");
    });
  };

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setDistCenterOptions([]);
    setfilter(filterInitialValues);
  };
  useEffect(() => {
    props.getAppGlobalSettingByVariableName("CreditBook_Version").then((response) => {
      if (response && response.variableValue) setAppVersion(response.variableValue);
    });
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
    props.getKYCContractStatusDDL().then((response) => {
      if (response) setContractStatusOption(response);
    });
  }, []);

  useEffect(() => {
    if (!filter.distributorId || filter.distributorId.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distributorId) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    }
    setDistCenterOptions([]);
  }, [filter.distributorId]);

  function formRequestObject() {
    let requestData = {
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.fromDate && formatDate(filter.toDate),
      status: filter.status?.value,
      ContractStatus: filter.contractStatus?.value,
      shopId: filter.shopId,
      pageSize: currentPageSize,
      pageNo: filter.pageNo,
      searchText: filter.searchText,
      distId: toCommaSeparated(filter.distributorId),
      distCenterId: toCommaSeparated(filter.distcentId),
      financerId: toCommaSeparated(filter.lenderId),
    };

    return requestData;
  }

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setfilter({ ...filter, searchText: text });
    var request = {
      ...formRequestObject(),
      searchText: text,
      currentPageNo: 0,
    };
    fetchReportData(request);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  const Download = () => {
    let request = { ...formRequestObject(), isExport: true };
    props.downloadJob(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageNo: 0, pageSize: pageSize };
    fetchReportData(request);
  };

  const getRecord = (id, isEdit = false, isV2 = false) => {
    Promise.all([
      props.getKycSingleRecord(id, isV2),
      isV2 ? props.getComplianceDocuments() : Promise.resolve(null),
    ]).then(([response, complianceDocuments]) => {
      if (!response) return;

      if (isV2) {
        const v2Kyc = normalizeV2Kyc(response, complianceDocuments);
        const rejectedEditableFields = getEditableV2Fields(v2Kyc);
        setSelectedKyc(response);
        setOriginalKycData(v2Kyc);
        setModalValues(v2Kyc);
        setEditableV2Fields(rejectedEditableFields);
        setShowV2ComplianceModal(true);
        return;
      }

      setSelectedKyc(response);
      setOriginalKycData({ ...response });
      setModalValues({ ...response });
      let ownership = ownershipColumns.find(
        (x) => x.value == response?.ownershipType
      );
      if (isEdit) {
        setModalValues({
          ...response,
          ownershipType: ownership,
          cnic: formatNumber(response.cnic, false),
          contactNo: formatNumber(response.contactNo, true),
        });
      } else {
        setModalValues({
          ...response,
          cnic: formatNumber(response.cnic, false),
          contactNo: formatNumber(response.contactNo, true),
        });
        setIsContractButtonVisible(
          response.kycStatus.toLowerCase() == "approved" &&
            response.contractStatus.toLowerCase() == "pending" &&
            isPermittedPage("Edit", props.actions, props.userRole)
        );
      }

      if (isEdit && isV2) {
        setShowV2ComplianceModal(true);
      } else {
        setShowV2ComplianceModal(false);
      }
    });
  };

  const viewRecord = async (id, download) => {
    setIsDownload(download);
    setIsView(true);
    setReadOnly(true);
    setIsEdit(false);

    const version =
      appVersion ||
      (await props.getAppGlobalSettingByVariableName("creditbook_version").then(
        (response) => {
          const value = response?.variableValue;
          if (value) {
            setAppVersion(value);
          }
          return value;
        }
      ));

    const isV2 = (version ?? "").toLowerCase() === "2";
    setIsV2Compliance(isV2);
    setShowV2ComplianceModal(false);
    getRecord(id, false, isV2);
  };

  const editRecord = async (id) => {
    setIsDownload(false);
    setReadOnly(false);
    setIsView(false);
    setIsEdit(true);

    const version =
      appVersion ||
      (await props.getAppGlobalSettingByVariableName("creditbook_version").then(
        (response) => {
          const value = response?.variableValue;
          if (value) {
            setAppVersion(value);
          }
          return value;
        }
      ));

    const isV2 = (version ?? "").toLowerCase() === "2";
    setIsV2Compliance(isV2);
    getRecord(id, true, isV2);
  };

  const closeModal = () => {
    setIsView(false);
    setIsEdit(false);
    setReadOnly(false);
    setSelectedKyc(null);
    setIsV2Compliance(false);
    setShowV2ComplianceModal(false);
    setEditableV2Fields([]);
  };
  useEffect(() => {
    setDistCenterOptions(
      props.selectedAddJobDistCentersList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.selectedAddJobDistCentersList]);

  const resetData = () => {
    let ownership = ownershipColumns.find(
      (x) => x.value == originalKycData?.ownershipType
    );
    setModalValues({ ...originalKycData, ownershipType: ownership });
  };

  const removeImage = (fieldName) => {
    modalValues[fieldName] = "";
  };

  const openUploadImage = (img) => {
    setSelectedImg(img);
    imgUploadRef.current.click();
  };

  const saveImage = (event) => {
    dispatch(showLoading());
    const extension = getImageExtensions();
    if (event.target.files.length > 0) {
      let currentExtension = event.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      if (!extension.includes(currentExtension)) {
        dispatch(hideLoading());
        toast.error("Selected invalid file extension");
        return;
      }
      uploadFile(event.target.files[0])
        .then((response) => {
          dispatch(hideLoading());
          imgUploadRef.current.value = null;
          modalValues[selectedImg] = response;
          setSelectedImg("");
        })
        .catch(function (error) {
          imgUploadRef.current.value = null;
          dispatch(hideLoading());
          toast.error(error);
        });
    } else {
      dispatch(hideLoading());
    }
  };

  const checkStatus = (type, current) => {
    switch (type) {
      case "revert":
        return 4;
      case "finalize":
        return 5;
      default:
        return current;
    }
  };

  const saveToasterMessage = (type) => {
    switch (type) {
      case 4:
        return "Record reverted to Shopkeeper";
      case 5:
        return "Record finalized";
      default:
        return "Record updated";
    }
  };

  const saveData = (formData, type) => {
    //let currentStatus = checkStatus(type, formData.status);
    if (formData.cnic != "" && formData.cnic != null) {
      formData.cnic = removeFormatFromNumber(formData.cnic);
    }
    if (formData.contactNo != "" && formData.contactNo != null) {
      formData.contactNo = removeFormatFromNumber(formData.contactNo);
    }
    let req = {
      ...formData,
      //status: currentStatus,
      // ownershipType:
      //   formData.ownershipType.value == undefined
      //     ? formData.ownershipType
      //     : formData.ownershipType.value,
    };

    props.updateUserKycProcess(req).then((data) => {
      if (!data) return;
      if (data.isSuccess) {
        toast.success(data.message);
        closeModal();
        getData(0);
      } else {
        toast.error(data.message);
      }
    });
  };

  const saveV2Data = (formData) => {
    if (!Array.isArray(editableV2Fields) || editableV2Fields.length === 0) {
      toast.error("No rejected field found to resubmit");
      return;
    }

    const editableSet = new Set(editableV2Fields);

    const buildComplianceDetails = (details, prefix) =>
      (details || []).reduce((acc, detail, detailIndex) => {
        const values = Array.isArray(detail?.values) ? detail.values : [];
        const isRequirementEditable =
          editableSet.has(`${prefix}.${detailIndex}.values.0`) ||
          values.some((_, valueIndex) =>
            editableSet.has(`${prefix}.${detailIndex}.values.${valueIndex}`)
          );
        const allowMultipleFiles =
          detail?.allowMultipleFiles === true || isMultipleFileRequirement(detail);
        const selectedValues = values
          .map((value, valueIndex) =>
            allowMultipleFiles && isRequirementEditable
              ? value
              : editableSet.has(`${prefix}.${detailIndex}.values.${valueIndex}`)
              ? value
              : null
          )
          .filter((v) => v !== null && String(v).trim() !== "");

        const isExplicitlySelected = editableSet.has(`${prefix}.${detailIndex}.values.0`);

        if (selectedValues.length > 0 || isExplicitlySelected) {
          acc.push({
            requirementName: detail.requirementName,
            values: selectedValues,
          });
        }
        return acc;
      }, []);

    const personalCompliance = buildComplianceDetails(
      formData.personalDetails?.complianceDetails,
      "personalDetails.complianceDetails"
    );
    const businessCompliance = buildComplianceDetails(
      formData.businessDetails?.complianceDetails,
      "businessDetails.complianceDetails"
    );

    const payload = {};
    if (personalCompliance.length > 0) {
      payload.PersonalEntity = { ComplianceDetails: personalCompliance };
    }
    if (businessCompliance.length > 0) {
      payload.BusinessEntity = { ComplianceDetails: businessCompliance };
    }

    if (!payload.PersonalEntity && !payload.BusinessEntity) {
      toast.error("No rejected compliance field found to resubmit");
      return;
    }

    const kycId = selectedKyc?.id || formData.id;

    props.saveCustomerInfoToUpdateByKycId(kycId, payload).then((data) => {
      if (!data) return;

      if (data.isSuccess) {
        toast.success(
          data.message ||
            data.response ||
            "Customer information updated successfully",
        );

        closeModal();
        getData(0);
      } else {
        toast.error(
          data.message ||
            data.response ||
            "Customer information could not be updated",
        );
      }
    });
  };

  useEffect(() => {
    // getKycList({})
    fetchReportData();
  }, []);

  const SyncContractStatus = (vizcode) => {
    props.changeContractStatusForWeb(vizcode).then((data) => {
      if (!data) return;
      data.isSuccess
        ? toast.success(data.response)
        : toast.error(data.response);
    });
  };

  return (
    <>
      <VzPageContainer title="KYC Form List">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>KYC Form List</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Row>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="distributor"
                                  label="Distributor"
                                  name="distributor"
                                  options={props.allDistributorList}
                                  isMulti={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      distributorId: e || [],
                                      distcentId: [],
                                    });
                                  }}
                                  value={filter.distributorId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="distcent"
                                  label="Dist Center"
                                  options={distCenterOptions}
                                  name="distcent"
                                  isMulti={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      distcentId: e || [],
                                    });
                                  }}
                                  value={filter.distcentId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="financer"
                                  label="Financer"
                                  options={props.allLenderList}
                                  name="financer"
                                  isMulti={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      lenderId: e || [],
                                    });
                                  }}
                                  value={filter.lenderId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="shopId"
                                  label="VIZ-ID"
                                  name="shopId"
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      shopId: AllowOnlyAlphaNumericWithDash(e),
                                    });
                                  }}
                                  value={filter.shopId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="KYC Status"
                                  name="status"
                                  options={statusOptions}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      status: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.status}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Contract Status"
                                  name="contractStatus"
                                  options={ContractStatusOption}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      contractStatus: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.contractStatus}
                                />
                              </Col>
                              <Row style={{ paddingRight: 0 }}>
                                <Col xs={12} md={6}>
                                  <FormikControl
                                    // formik={formik}
                                    control="date"
                                    label="From Date"
                                    name="fromDate"
                                    handleOnChange={(value) => {
                                      setfilter({ ...filter, fromDate: value });
                                    }}
                                    value={filter.fromDate}
                                  />
                                </Col>
                                <Col xs={12} md={6}>
                                  <FormikControl
                                    // formik={formik}
                                    control="date"
                                    label="To Date"
                                    name="toDate"
                                    handleOnChange={(value) => {
                                      setfilter({ ...filter, toDate: value });
                                    }}
                                    value={filter.toDate}
                                  />
                                </Col>
                              </Row>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={kycList ?? []}
              columns={columns}
              getTrProps={(event, data) => { }}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
        <Modal
          show={!isV2Compliance && (isView || isEdit)}
          onHide={closeModal}
          backdrop="static"
          keyboard={false}
          size="xl"
        >
          <Formik
            enableReinitialize
            initialValues={modalValues}
            validationSchema={null}
          // onSubmit={saveData}
          >
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    {isDownload && (
                      <ReactToPrint
                        trigger={() => <Button>Download</Button>}
                        content={() => printRef.current}
                        documentTitle="KYC"
                      />
                    )}
                    {/* {isEdit && <Button onClick={resetData}>Reset</Button>} */}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body ref={printRef}>
                  {!isEdit ? (
                    <>
                      <Row>
                        <Col>
                          <div className="card-header">
                            <h5>
                              <b style={{ color: " #ea5f2d" }}>KYC Listing:</b>
                            </h5>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                            }}
                          >
                            Main Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    style={{ margin: "25px 0px 0px 0px" }}
                                    control="date"
                                    type="date"
                                    // label='Shop Owner Name'
                                    name="date"
                                    value={modalValues.date}
                                    handleOnChange={(e) =>
                                      (modalValues.date = e)
                                    }
                                    readOnly="true"
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                VIZ ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="vizId"
                                    // label='Shop Owner Name'
                                    name="vizId"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.vizId = e)
                                    }
                                    value={modalValues.vizId}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Financer ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="financerId"
                                    // label="Father's Name"
                                    name="financerId"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.financerId = e)
                                    }
                                    value={modalValues.financerId}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                KYC Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="kycStatus"
                                    // label="Mother's Name"
                                    name="kycStatus"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.kycStatus = e)
                                    }
                                    value={modalValues.kycStatus}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contract Status
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xl={isContractButtonVisible ? 10 : 12}>
                                    <div className="form-group">
                                      <FormikControl
                                        formik={formik}
                                        control="input"
                                        type="contractStatus"
                                        // label="Father's Name"
                                        name="contractStatus"
                                        readOnly="true"
                                        handleOnChange={(e) =>
                                          (modalValues.contractStatus = e)
                                        }
                                        value={modalValues.contractStatus}
                                      />
                                    </div>
                                  </Col>
                                  {isContractButtonVisible ? (
                                    <Col xs={2}>
                                      <button
                                        style={{ marginTop: "4px" }}
                                        className="btn btn-sm btn-warning"
                                        title="Sync Contract"
                                        onClick={() =>
                                          SyncContractStatus(modalValues.vizId)
                                        }
                                      >
                                        <i className="fa fa-history"></i>
                                      </button>
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                              <Col xs={2} className="text-right">
                                Assign Limit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="assignLimit"
                                    // label="Mother's Name"
                                    name="assignLimit"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.assignLimit = e)
                                    }
                                    value={modalValues.assignLimit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Reason for Rejection
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="reason"
                                    // label='CNIC No.'
                                    name="reason"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.reason = e)
                                    }
                                    value={modalValues.reason}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Front Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not found"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicFront || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("cnicFront")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("cnicFront")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Back Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicBack || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("cnicBack")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("cnicBack")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-91px"
                            }}
                          >
                            Personal Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Owner Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="ownerName"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="ownerName"
                                    handleOnChange={(e) =>
                                      (modalValues.ownerName = e)
                                    }
                                    value={modalValues.ownerName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Father Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="fatherName"
                                    // label='Shop Owner Name'
                                    name="fatherName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.fatherName = e)
                                    }
                                    value={modalValues.fatherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                DOB
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    type="dateOfBirth"
                                    // label="Father's Name"
                                    name="dateOfBirth"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.dateOfBirth = e)
                                    }
                                    value={modalValues.dateOfBirth}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Mother Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="motherName"
                                    // label="Mother's Name"
                                    name="motherName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.motherName = e)
                                    }
                                    value={modalValues.motherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="cnic"
                                    // label="Father's Name"
                                    name="cnic"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.cnic = e)
                                    }
                                    value={modalValues.cnic}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                CNIC Issuance Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Issuance Date'
                                    name="cnicIssuanceDate"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.cnicIssuanceDate = value;
                                    }}
                                    value={modalValues.cnicIssuanceDate}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Expiry Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Expiry Date'
                                    name="cnicExpiryDate"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.cnicExpiryDate = value;
                                    }}
                                    value={modalValues.cnicExpiryDate}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Email
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="email"
                                    readOnly="true"
                                    // label='CNIC Expiry Date'
                                    name="email"
                                    handleOnChange={(value) => {
                                      modalValues.email = value;
                                    }}
                                    value={modalValues.email}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contact #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    // label='CNIC Issuance Date'
                                    name="contactNo"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.contactNo = value;
                                    }}
                                    value={modalValues.contactNo}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                UserName
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    name="UserName"
                                    readOnly="true"
                                    value={modalValues.userName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Home Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <div className="form-group">
                                    <FormikControl
                                      formik={formik}
                                      control="input"
                                      type="currentHomeAddress"
                                      // label='CNIC No.'
                                      readOnly="true"
                                      name="currentHomeAddress"
                                      handleOnChange={(e) =>
                                        (modalValues.currentHomeAddress = e)
                                      }
                                      value={modalValues.currentHomeAddress}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="cnicHomeAddress"
                                    // label='CNIC No.'
                                    name="cnicHomeAddress"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.cnicHomeAddress = e)
                                    }
                                    value={modalValues.cnicHomeAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Owner Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.ownerPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("ownerPicture")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() =>
                                        removeImage("ownerPicture")
                                      }
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Shop Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.shopPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("shopPicture")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("shopPicture")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-30px",
                            }}
                          >
                            Business Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessName"
                                    // label='Shop Owner Name'
                                    name="businessName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessName = e)
                                    }
                                    value={modalValues.businessName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop OwnerShip
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    type="ownershipType"
                                    // label='Shop Ownership'
                                    name="ownershipType"
                                    readOnly="true"
                                    options={ownershipColumns}
                                    handleOnChange={(e) =>
                                      (modalValues.ownershipType = e)
                                    }
                                    value={modalValues.ownershipType}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Shop height
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopHeight"
                                    // label="Father's Name"
                                    name="shopHeight"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.shopHeight = e)
                                    }
                                    value={modalValues.shopHeight}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop Width
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopWidth"
                                    // label="Mother's Name"
                                    name="shopWidth"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.shopWidth = e)
                                    }
                                    value={modalValues.shopWidth}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Type
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessType"
                                    // label="Father's Name"
                                    name="businessType"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessType = e)
                                    }
                                    value={modalValues.businessType}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Required Credit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="requiredCredit"
                                    // label="Mother's Name"
                                    name="requiredCredit"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.requiredCredit = e)
                                    }
                                    value={modalValues.requiredCredit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessAddress"
                                    readOnly="true"
                                    // label='CNIC No.'
                                    name="businessAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.businessAddress = e)
                                    }
                                    value={modalValues.businessAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col>
                          <div className="card-header">
                            <div style={{ display: "flex", alignItems: "center", position: "relative" }}>

                              {/* Left text */}
                              <b style={{ color: "#ea5f2d" }}>KYC Listing:</b>

                              {/* Center text */}
                              <div style={{
                                marginLeft: "40px",
                                color: "#ed8856ff"
                              }}>
                                {modalValues.previousSubmittedMessage}
                              </div>

                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                            }}
                          >
                            Main Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    style={{ margin: "20px 0px 0px 0px" }}
                                    formik={formik}
                                    control="date"
                                    type="date"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="date"
                                    value={modalValues.date}
                                    handleOnChange={(e) =>
                                      (modalValues.date = e)
                                    }
                                    isDisabled={isView}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                VIZ ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="vizId"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="vizId"
                                    handleOnChange={(e) =>
                                      (modalValues.vizId = e)
                                    }
                                    value={modalValues.vizId}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Financer ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="financerId"
                                    readOnly="true"
                                    // label="Father's Name"
                                    name="financerId"
                                    handleOnChange={(e) =>
                                      (modalValues.financerId = e)
                                    }
                                    value={modalValues.financerId}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                KYC Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    readOnly="true"
                                    type="kycStatus"
                                    // label="Mother's Name"
                                    name="kycStatus"
                                    handleOnChange={(e) =>
                                      (modalValues.kycStatus = e)
                                    }
                                    value={modalValues.kycStatus}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contract Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    readOnly="true"
                                    type="contractStatus"
                                    // label="Father's Name"
                                    name="contractStatus"
                                    handleOnChange={(e) =>
                                      (modalValues.contractStatus = e)
                                    }
                                    value={modalValues.contractStatus}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Assign Limit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    readOnly="true"
                                    control="input"
                                    type="assignLimit"
                                    // label="Mother's Name"
                                    name="assignLimit"
                                    handleOnChange={(e) =>
                                      (modalValues.assignLimit = e)
                                    }
                                    value={modalValues.assignLimit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Reason for Rejection
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    readOnly="true"
                                    control="input"
                                    type="reason"
                                    // label='CNIC No.'
                                    name="reason"
                                    handleOnChange={(e) =>
                                      (modalValues.reason = e)
                                    }
                                    value={modalValues.reason}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Front Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not found"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicFront || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() => openUploadImage("cnicFront")}
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("cnicFront")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Back Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicBack || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() => openUploadImage("cnicBack")}
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("cnicBack")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-150px"
                            }}
                          >
                            Personal Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Owner Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="ownerName"
                                    // label='Shop Owner Name'
                                    name="ownerName"
                                    handleOnChange={(e) =>
                                    (modalValues.ownerName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.ownerName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Father Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="fatherName"
                                    maxLength={70}
                                    // label='Shop Owner Name'
                                    name="fatherName"
                                    handleOnChange={(e) =>
                                    (modalValues.fatherName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.fatherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                DOB
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    type="date"
                                    // label="Father's Name"
                                    name="dateOfBirth"
                                    handleOnChange={(e) =>
                                      (modalValues.dateOfBirth = e)
                                    }
                                    value={modalValues.dateOfBirth}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Mother Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="motherName"
                                    // label="Mother's Name"
                                    name="motherName"
                                    handleOnChange={(e) =>
                                    (modalValues.motherName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.motherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="cnicNumber"
                                    type="cnic"
                                    // label="Father's Name"
                                    name="cnic"
                                    handleOnChange={(e) =>
                                      (modalValues.cnic = e)
                                    }
                                    value={modalValues.cnic}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                CNIC Issuance Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Issuance Date'
                                    name="cnicIssuanceDate"
                                    handleOnChange={(value) => {
                                      modalValues.cnicIssuanceDate = value;
                                    }}
                                    value={modalValues.cnicIssuanceDate}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Expiry Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Expiry Date'
                                    name="cnicExpiryDate"
                                    handleOnChange={(value) => {
                                      modalValues.cnicExpiryDate = value;
                                    }}
                                    value={modalValues.cnicExpiryDate}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Email
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="email"
                                    readOnly={modalValues.kycStatus === "Error" ? false : true}
                                    // label='CNIC Expiry Date'
                                    name="email"
                                    handleOnChange={(value) => {
                                      modalValues.email = value;
                                    }}
                                    value={modalValues.email}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contact #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="contactNumber"
                                    // label='CNIC Issuance Date'
                                    name="contactNo"
                                    handleOnChange={(value) => {
                                      modalValues.contactNo = value;
                                    }}
                                    value={modalValues.contactNo}
                                  />
                                </div>
                              </Col>
                              <Col xs={6}></Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Home Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <div className="form-group">
                                    <FormikControl
                                      formik={formik}
                                      maxLength={254}
                                      control="input"
                                      type="currentHomeAddress"
                                      // label='CNIC No.'
                                      name="currentHomeAddress"
                                      handleOnChange={(e) =>
                                        (modalValues.currentHomeAddress = e)
                                      }
                                      value={modalValues.currentHomeAddress}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={254}
                                    type="cnicHomeAddress"
                                    // label='CNIC No.'
                                    name="cnicHomeAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.cnicHomeAddress = e)
                                    }
                                    value={modalValues.cnicHomeAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Owner Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.ownerPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() =>
                                      openUploadImage("ownerPicture")
                                    }
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("ownerPicture")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Shop Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.shopPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() =>
                                      openUploadImage("shopPicture")
                                    }
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("shopPicture")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-100px",
                            }}
                          >
                            Business Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessName"
                                    // label='Shop Owner Name'
                                    name="businessName"
                                    maxLength={70}
                                    handleOnChange={(e) =>
                                    (modalValues.businessName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.businessName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop OwnerShip
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    type="ownershipType"
                                    // label='Shop Ownership'
                                    name="ownershipType"
                                    options={ownershipColumns}
                                    handleOnChange={(e) =>
                                      (modalValues.ownershipType = e)
                                    }
                                    value={modalValues.ownershipType}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Shop height
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopHeight"
                                    // label="Father's Name"
                                    name="shopHeight"
                                    maxLength={12}
                                    handleOnChange={(e) =>
                                    (modalValues.shopHeight =
                                      AllowOnlyDecimal(e))
                                    }
                                    value={modalValues.shopHeight}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop Width
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopWidth"
                                    maxLength={12}
                                    // label="Mother's Name"
                                    name="shopWidth"
                                    handleOnChange={(e) =>
                                    (modalValues.shopWidth =
                                      AllowOnlyDecimal(e))
                                    }
                                    value={modalValues.shopWidth}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Type
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessType"
                                    // label="Father's Name"
                                    name="businessType"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessType = e)
                                    }
                                    value={modalValues.businessType}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Required Credit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="requiredCredit"
                                    maxLength={11}
                                    // label="Mother's Name"
                                    name="requiredCredit"
                                    handleOnChange={(e) =>
                                    (modalValues.requiredCredit =
                                      AllowOnlyNumeric(e))
                                    }
                                    value={modalValues.requiredCredit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={254}
                                    type="businessAddress"
                                    // label='CNIC No.'
                                    name="businessAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.businessAddress = e)
                                    }
                                    value={modalValues.businessAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </Modal.Body>
                {isEdit && modalValues?.status != 4 && (
                  <Modal.Footer className="d-flex justify-content-between float-right">
                    {
                      <div>
                        {/* <Button className="btn btn-default" onClick={resetData}>
                           Cancel
                         </Button> */}

                        <Button
                          className="btn btn-primary mx-4"
                          onClick={() => saveData(formik.values, "save")}
                        >
                          Save
                        </Button>
                      </div>
                    }
                  </Modal.Footer>
                )}
              </Form>
            )}
          </Formik>
        </Modal>
        <KYCListingFormComplianceViewModal
          show={showV2ComplianceModal && isView}
          onHide={closeModal}
          modalValues={modalValues}
        />
        <KYCListingFormComplianceModal
          show={showV2ComplianceModal && isEdit}
          onHide={closeModal}
          modalValues={modalValues}
          saveData={saveV2Data}
          isEdit={isEdit}
          readOnly={readOnly}
          editableFields={editableV2Fields}
        />
      </VzPageContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],

    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    KYCListingForm: state.KYCListingForm,
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getKYCListingForm,
  toggleKYCActive,
  getKYCContractStatusDDL,
  getKycSingleRecord,
  updateUserKycProcess,
  changeContractStatusForWeb,
  getAppGlobalSettingByVariableName,
  getComplianceDocuments,
  submitCreditBookV2KYC,
  saveCustomerInfoToUpdateByKycId,
})(KYCListingForm);
